import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

const Section1 = ({ url }) => {
  useEffect(() => {
    const spotlightSize = 400;

    function handleMouseMove(event) {
      if (window.event) {
        event = window.event;
      }
      let titleRect = document
        .querySelector(".hollow-txt")
        .getBoundingClientRect();
      let mouseX = event.clientX;
      let spotlightX = mouseX - spotlightSize / 2 - titleRect.left;
      let mouseY = event.clientY;
      let spotlightY = mouseY - spotlightSize / 2 - titleRect.top;
      const element = document.querySelector(".hollow-txt");
      element.style.backgroundPosition = spotlightX + "px " + spotlightY + "px";
    }

    document.addEventListener("mousemove", handleMouseMove, false);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <>
      <section
        className="services-section-1"
        style={{
          backgroundImage: "url(" + url + "images/services/main-banner.jpg)",
        }}
      >
        <div className="container sect-1-container col-12">
          <div
            className="txt-1 col-12"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="white-txt">Brand</h1>
          </div>
          <div
            className="txt-2 col-12"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <p className="hollow-txt">Services</p>
          </div>
          <div
            className="services-desc"
            data-aos="fade-up"
            data-aos-duration="1400"
          >
            <h6 className="desc">
              From AI-Powered innovation, Customize Website & App Development to Social Media Marketing and Branding, we've got it all!
            </h6>
            {/* <h6 className="desc">
              From start to scaling, ExD Digital is there to help your brand at
              any stage, whether it be launch or growth.
            </h6> */}
          </div>
          <div className="scroller">
            <p className="scroller-text">Explore More</p>
            <a href="#services-section" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faArrowDown} className="i" />
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section1;
